import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ConnectAccountResponse } from "src/pages/Link/DynamicForm/services/useSelectServiceConnect";
import { apiClient } from "src/services/config/apiClient";
import { API } from "src/services/config/apiConfig";

import { ConnectDemoAccountPayload } from "./NetTypes";

async function connectAccountDemoRequest(payload: ConnectDemoAccountPayload, token: string) {
	return await apiClient
		.post(API.COMMAND.DEMO.CONNECT_ACCOUNT, payload, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
		.then((res) => res.data);
}

export function useConnectDemoAccountRequest(token: string) {
	return useMutation<ConnectAccountResponse, AxiosError, ConnectDemoAccountPayload>({
		mutationFn: (payload: ConnectDemoAccountPayload) => connectAccountDemoRequest(payload, token)
	});
}
